export default __webpack_public_path__ + "static/media/54039.0be3b37d.jpg";